import React from 'react'
import Title from './Title'
import Skills from './Skills'
import Project from './Project'
import Services from './Services'
import Animation from './Animation'
import Textanimate from './Textanimate'

function Main() {
  return (
    <div>
      <Title titleh1='Skills' titleh2='Programming languages'/>
      <Skills/>
      <Title titleh1='PROJETS' titleh2='portfolio'/>
      <Project 
        project='project Enjoy' 
        nameproject='project Enjoy' 
        library='tailwind - react' 
        statusres='Responsive' 
        linkdemo='https://mohammadjodaki.github.io/project-Enjoy-js' 
        linkgit='https://github.com/mohammadjodaki/project-Enjoy-js'
        image1='Image/pic1-1.png'
        image2='Image/pic1-2.png'
        image3='Image/pic1-3.png'
        image4='Image/pic1-4.png'
      />
      <Project 
        project='project winery' 
        nameproject='project winery' 
        library='tailwind' 
        statusres='Responsive' 
        linkdemo='https://mohammadjodaki.github.io/project-winery-tailwind' 
        linkgit='https://github.com/mohammadjodaki/project-winery-tailwind' 
        image1='Image/pic2-1.png'
        image2='Image/pic2-2.png'
        image3='Image/pic2-3.png'
        image4='Image/pic2-4.png'
      />
      <Project 
        project='crypto price' 
        nameproject='crypto price' 
        library='tailwind' 
        statusres='Responsive' 
        linkdemo='https://mohammadjodaki.github.io/crypto-price' 
        linkgit='https://github.com/mohammadjodaki/crypto-price' 
        image1='Image/pic3-1.png'
        image2='Image/pic3-1.png'
        image3='Image/pic3-1.png'
        image4='Image/pic3-1.png'
      />
      <Project 
        project='to do list' 
        nameproject='to do list' 
        library='tailwind' 
        statusres='Responsive' 
        linkdemo='https://mohammadjodaki.github.io/to-do-list' 
        linkgit='https://github.com/mohammadjodaki/to-do-list' 
        image1='Image/pic4-1.png'
        image2='Image/pic4-2.png'
        image3='Image/pic4-1.png'
        image4='Image/pic4-2.png'
      />
      <Project 
        project='Accordion' 
        nameproject='Accordion' 
        library='tailwind' 
        statusres='Responsive' 
        linkdemo='https://mohammadjodaki.github.io/Accordion.js' 
        linkgit='https://github.com/mohammadjodaki/Accordion.js' 
        image1='Image/pic5-1.png'
        image2='Image/pic5-1.png'
        image3='Image/pic5-1.png'
        image4='Image/pic5-1.png'
      />
      <Project 
        project='login' 
        nameproject='login' 
        library='tailwind' 
        statusres='no Responsive' 
        linkdemo='https://mohammadjodaki.github.io/login-js' 
        linkgit='https://github.com/mohammadjodaki/login-js' 
        image1='Image/pic6-1.png'
        image2='Image/pic6-2.png'
        image3='Image/pic6-1.png'
        image4='Image/pic6-2.png'
      />
      <Title titleh1='EXPERIENCES' titleh2='en développement'/>
      <Services/>
      <Title titleh1='DIPLOMES' titleh2='en développement'/>
      <Animation/>
      <Textanimate/>
    </div>
  )
}

export default Main